import { Grid } from "@mui/material";
import { fDate } from "../../../utils/formatTime";

const PrefentialQualDetails = (_props) => {
    const { candidateData, className } = _props
    return (
        <fieldset className={`${className}--fieldset`}>
            <legend className={`${className}--legend`}>
                Preferential Qualification
            </legend>
            {/* for web preview */}
            <div className="print-web">
                <Grid container spacing={1}>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Have you Served in the Territorial army for a minimum
                            period of two years?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText custom-rht`}>
                            {String(candidateData?.is_served_territorial_army) === "1" && "Yes"}
                            {String(candidateData?.is_served_territorial_army) === "0" && "No"}
                            {String(candidateData?.is_served_territorial_army) !== "1" &&
                                String(candidateData?.is_served_territorial_army) !== "0" &&
                                "-"}
                        </p>
                    </Grid>
                    {Number(candidateData?.is_served_territorial_army) ===
                        1 ? (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Date of Attestation
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.ta_attestation_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    Date of Discharge
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.ta_discharge_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                        </>
                    ) : null}
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Do you possesses National Cadet Corps 'B'
                            certificate?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText custom-rht`}>
                            {String(candidateData?.is_b_ncc) === "1" && "Yes"}
                            {String(candidateData?.is_b_ncc) === "0" && "No"}
                            {String(candidateData?.is_b_ncc) !== "1" &&
                                String(candidateData?.is_b_ncc) !== "0" &&
                                "-"}
                        </p>
                    </Grid>

                    {Number(candidateData?.is_b_ncc) === 1 ? (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    National Cadet Corps "B" Acquiring Date{" "}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.b_ncc_acquiring_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    National Cadet Corps "B" Certificate Number{" "}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.b_ncc_certificate_no}
                                </p>
                            </Grid>
                        </>
                    ) : null}

                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--text`}>
                            Do you possesses National Cadet Corps "C"
                            certificate?
                        </p>
                    </Grid>
                    <Grid item lg={6} md={6} sm={6} xs={6}>
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_c_ncc) === "1" && "Yes"}
                            {String(candidateData?.is_c_ncc) === "0" && "No"}
                            {String(candidateData?.is_c_ncc) !== "1" &&
                                String(candidateData?.is_c_ncc) !== "0" &&
                                "-"}
                        </p>
                    </Grid>

                    {Number(candidateData?.is_c_ncc) === 1 ? (
                        <>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    National Cadet Corps "C" Acquiring Date{" "}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.c_ncc_acquiring_date, 'dd/MM/yyyy')}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--text`}>
                                    National Cadet Corps "C" Certificate Number{" "}
                                </p>
                            </Grid>
                            <Grid item lg={6} md={6} sm={6} xs={6}>
                                <p className={`${className}--subText`}>
                                    {candidateData?.c_ncc_certificate_no}
                                </p>
                            </Grid>
                        </>
                    ) : null}
                </Grid>
            </div>
            {/* for print view */}
            <div className="print-view">
                <div className="print-details d-flex">
                    <div className="w-80">
                        <p className={`${className}--text`}>
                            Have you Served in the Territorial army for a minimum
                            period of two years?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_served_territorial_army) === "1" && "Yes"}
                            {String(candidateData?.is_served_territorial_army) === "0" && "No"}
                            {String(candidateData?.is_served_territorial_army) !== "1" &&
                                String(candidateData?.is_served_territorial_army) !== "0" &&
                                "-"}
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_served_territorial_army) ===
                    1 ? (
                    <>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    Date of Attestation
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.ta_attestation_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    Date of Discharge
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.ta_discharge_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                    </>
                ) : null}

                <div className="print-details d-flex">
                    <div className="w-80">
                        <p className={`${className}--text`}>
                            Do you possesses National Cadet Corps 'B'
                            certificate?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_b_ncc) === "1" && "Yes"}
                            {String(candidateData?.is_b_ncc) === "0" && "No"}
                            {String(candidateData?.is_b_ncc) !== "1" &&
                                String(candidateData?.is_b_ncc) !== "0" &&
                                "-"}
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_b_ncc) === 1 ? (
                    <>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    National Cadet Corps "B" Acquiring Date{" "}
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.b_ncc_acquiring_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    National Cadet Corps "B" Certificate Number{" "}
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {candidateData?.b_ncc_certificate_no}
                                </p>
                            </div>
                        </div>

                    </>
                ) : null}
                <div className="print-details d-flex">
                    <div className="w-80">
                        <p className={`${className}--text`}>
                            Do you possesses National Cadet Corps 'C'
                            certificate?
                        </p>
                    </div>
                    <div className="w-20">
                        <p className={`${className}--subText`}>
                            {String(candidateData?.is_c_ncc) === "1" && "Yes"}
                            {String(candidateData?.is_c_ncc) === "0" && "No"}
                            {String(candidateData?.is_c_ncc) !== "1" &&
                                String(candidateData?.is_c_ncc) !== "0" &&
                                "-"}
                        </p>
                    </div>
                </div>
                {Number(candidateData?.is_c_ncc) === 1 ? (
                    <>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    National Cadet Corps "C" Acquiring Date{" "}
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {fDate(candidateData?.c_ncc_acquiring_date, 'dd/MM/yyyy')}
                                </p>
                            </div>
                        </div>
                        <div className="print-details d-flex">
                            <div className="w-80">
                                <p className={`${className}--text`}>
                                    National Cadet Corps "C" Certificate Number{" "}
                                </p>
                            </div>
                            <div className="w-20">
                                <p className={`${className}--subText`}>
                                    {candidateData?.c_ncc_certificate_no}
                                </p>
                            </div>
                        </div>

                    </>
                ) : null}
            </div>
        </fieldset>
    )
}

export default PrefentialQualDetails;